import { GET_SKIDS_FOR_PRODUCT_TRANSFER } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_SKIDS_FOR_PRODUCT_TRANSFER:
            return action.payload;
        default:
            return state;
    }
}